<odx-modal-header>
  <odx-area-header>{{ title }}</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (!isLoading() && !showCategory && tableRows().length >= 1) {
    <div class="monitoring-item-details-scroll">
      <div class="monitoring-item-details-content">
        <app-monitoring-grouped-parts-table [rows]="tableRows()" [showCategory]="false"></app-monitoring-grouped-parts-table>
      </div>
    </div>
  } @else if (!isLoading() && showCategory && summarySections().length >= 1) {
    <div class="monitoring-item-details-scroll">
      <div class="monitoring-item-details-content">
        <app-monitoring-overview [sections]="summarySections()" [showCategory]="true" [showHeader]="false" />
      </div>
    </div>
  } @else if (!isLoading()) {
    <p i18n="@@group.modal.attachments.noAttachments">Keine Sachnummern zum Anzeigen vorhanden</p>
  }
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="primary" i18n="@@group.modal.button.close" (click)="onConfirm()">Schließen</button>
</odx-modal-footer>
